<template>
    <main class="page-main">
        <Breadcrumbs>
            <template slot="li">
                <li>/<span> Search Client</span></li>
            </template>
        </Breadcrumbs>

        <div class="block">
            <div class="container">
                <div class="title center">
                    <h1>Search Client</h1>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="container">
                <SearchData
                    :route="$route.path + '/'"
                    :searchByFields="searchableFields"
                    :defaultSearchField="seachField"
                    :tableFields="tableFields">
                    <template slot="assigned-vouchers" slot-scope="{ data }">
                        <a style="cursor: pointer" v-if="data.vouchers.length"
                            @click="showVouchers(data.vouchers, data.client.nif)"
                            class="pull-right">
                                <span> See vouchers</span>
                        </a>
                    </template>

                    <template slot="is-active" slot-scope="{ data }">
                        <span v-if="data.client.active == 1">
                            <span class="icon icon-check check" style="color: green"></span>
                        </span>
                        <span v-else>
                            <span class="icon icon-close-1 cross" style="color: red"></span>
                        </span>
                    </template>

                    <!-- Sales -->
                    <template slot="sales" slot-scope="{ data }">
                        <a style="cursor: pointer"
                            @click="showSales(data.client)"
                            class="pull-right">
                                <span> Register new</span>
                        </a>
                    </template>

                    <!-- Options -->
                    <template slot="options" slot-scope="{ data }">
                        <button class="btn" @click="$router.push({name: 'ClientEdit', params: { id: data.client.id}})">Edit</button>
                    </template>
                </SearchData>
            </div>
        </div>

        <!-- Vouchers Modal -->
        <Modal v-if="showVModal" @close="showVModal = false">
            <Loading :is-loading="loading"></Loading>
            <div slot="header">Vouchers Assigned to the Client with NIF: {{ currentClient.nif }}</div>
            <div slot="body">
                <SearchData ref="voucherSearch"
                    :isSearchableByFields="false"
                    :isSearchableByInput="false"
                    :tableFields="vouchersFields"
                    :customSearchData="vouchers">
                    <!-- Voucher status -->
                    <template slot="isUsed" slot-scope="{ data }">
                         <span v-if="data.used == 1">
                            <span class="icon icon-check check" style="color: green"></span>
                        </span>
                        <span v-else>
                            <span class="icon icon-close-1 cross" style="color: red"></span>
                        </span>
                    </template>
                    <!-- Voucher options -->
                    <template slot="options" slot-scope="{ data }">
                        <VoucherOptions :voucher="data" @onError="error = $event"></VoucherOptions>
                    </template>
                </SearchData>
            </div>
            <div slot="footer">
                <div v-if="error" class="alert alert-danger" style="text-align: center">{{ error }}</div>
            </div>
        </Modal>

        <!-- Sales Modal -->
        <Modal v-if="showSModal" @close="showSModal = false">
            <div slot="header">
                <h2>Register new Sale</h2>
            </div>
            <div slot="body">
                <Loading :is-loading="loading"></Loading>
                <div class="form-group">
                    <input type="number" v-model="ftId" class="form-control" placeholder="Doc ID">
                </div>
                <div>
                    <input type="date" v-model="ftDate" class="form-control">
                </div>
                <button class="btn" :disabled="!ftId" @click="registerSale">Save</button>

                <p></p>
                <SearchData ref="salesSearch" @onSearch="getSales"
                    :key="salesKeyRef"
                    :route="'sales/search/'"
                    :defaultSearchField="'nif'"
                    :isSearchableByFields="false"
                    :isSearchableByInput="false"
                    :tableFields="salesFields">
                    <!-- sales status -->
                    <template slot="isAssigned" slot-scope="{ data }">
                        <span v-if="data.client_id">
                            <span class="icon icon-check check" style="color: green"></span>
                        </span>
                        <span v-else>
                            <span class="icon icon-close-1 cross" style="color: red"></span>
                        </span>
                    </template>
                    <!-- sales options -->
                    <template slot="options" slot-scope="{ data }">
                        <span v-if="!data.handled">
                            <button class="btn" @click="removeSale(data)">Remove *</button>
                        </span>
                    </template>

                </SearchData>
            </div>
            <div slot="footer">
                Maximum day to remove a sale: Today
            </div>
        </Modal>
    </main>
</template>

<script>
import axios from 'axios'
import Loading from '../../mixins/components/Loading'
import Modal from '../../mixins/components/Modal'
import SearchData from '../../mixins/components/SearchComponent'
import VoucherOptions from '../vouchers/plugins/Actions'

export default {
    name: "ClientSearch",
    components: {
        Loading, Modal, SearchData, VoucherOptions
    },
    data () {
        return {
            loading: false,
            searchableFields: [
                {
                    name: 'nif',
                    label: 'NIF',
                    active: true
                },
                {
                    name: 'email',
                    label: 'EMAIL',
                    active: false
                },
                {
                    name: 'tlm',
                    label: 'TELEPHONE',
                    active: false
                },
                {
                    name: 'cc',
                    label: 'CC / BI',
                    active: false
                }
            ],
            tableFields: [
                {
                    label: 'Card',
                    name: 'data.card.card_mc_id',
                    isBold: true,
                    slot: ''
                },
                {
                    label: 'Name',
                    name: 'data.client.name',
                    isBold: false,
                    slot: ''
                },
                {
                    label: 'E-mail',
                    name: 'data.client.email',
                    isBold: false,
                    slot: ''
                },
                {
                    label: 'NIF',
                    name: 'data.client.nif',
                    isBold: false,
                    slot: ''
                },
                {
                    label: 'Vouchers Assigned',
                    name: 'data.vouchers.length',
                    isBold: false,
                    slot: 'assigned-vouchers'
                },
                {
                    label: 'Active',
                    name: '',
                    isBold: false,
                    slot: 'is-active'
                },
                {
                    label: 'Modified',
                    name: 'data.client.updated_at',
                    isBold: false,
                    slot: ''
                },
                {
                    label: 'Sales',
                    name: '',
                    isBold: false,
                    slot: 'sales'
                },
            ],
            seachField: 'nif',
            currentClient: {},
            searchVal: null,
            clients: [],
            vouchers: [],
            vouchersFields: [
                {
                    label: 'Code',
                    name: 'data.code',
                    isBold: true,
                },
                {
                    label: 'Value',
                    name: 'data.value',
                },
                {
                    label: 'Used',
                    name: '',
                    slot: 'isUsed'
                }
            ],
            showVModal: false,
            showSModal: false,
            error: null,

            salesKeyRef: 1,
            salesFields: [
                {
                    label: 'ID',
                    name: 'data.doc_id',
                    isBold: true,
                },
                {
                    label: 'Date',
                    name: 'data.doc_date',
                },
                {
                    label: 'Assigned',
                    name: '',
                    slot: 'isAssigned'
                }
            ],

            ftId: null,
            ftDate: this.getCurrentDate()
        }
    },
    methods: {

        // force sales search by Client
        getSales (obj) {
            return obj.search('all', this.currentClient.id)
        },

        // show sales list modal
        showSales (client) {
            this.showSModal = true
            this.currentClient = client
        },

        // show vouchers list modal
        showVouchers (vouchers, nif) {
            this.vouchers = vouchers
            this.currentClient.nif = nif
            this.showVModal = true
        },

        // register new sale for current client
        registerSale () {
            let docId = parseInt(this.ftId)
            this.ftId = null
            this.loading = true
            this.api().post('sales/register', {
                doc_id: docId,
                doc_date: this.ftDate,
                client_id: this.currentClient.id
            })
                .then(({data}) => {
                    this.loading = false
                    this.ftDate = this.getCurrentDate()
                    this.salesKeyRef += 1
                    this.alert(data.response, 'success')
                })
                .catch(({response}) => {
                    this.loading = false
                    if (response)
                        this.alert(response.data.response[0], 'error')
                })
        },

        // remove a invalid sale
        removeSale (sale) {
            let result = confirm('Do you really want to remove this sale?')
            if (result) {
                this.loading = true
                this.api().delete('sales/delete/' + sale.doc_id)
                    .then(({data}) => {
                        this.loading = false
                        this.salesKeyRef += 1
                        this.alert(data.response, 'success')
                    })
                    .catch(({response}) => {
                        this.loading = false
                        if (response)
                            this.alert(response.data.response[0], 'error')
                    })
            }
        },

        // get current date
        getCurrentDate () {
            const date = new Date
            let
                d = date.getDate(),
                m = (date.getMonth() + 1)
            return date.getFullYear() + '-' + (m >= 10 ? m : '0' + m) + '-' + (d >= 10 ? d : '0' + d)
        }
    }
}
</script>

<style>
    .swal2-container.swal2-shown {
        z-index: 9999 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/clients/Search.vue